<div class="simple-table-container shadow-sm">
  <div class="overflow-auto w-100" *ngIf="!isMobile; else mobile">
    <table class="w-100 table-borderless">
      <thead>
        <tr class="text-center" *ngIf="!isAdvancedColumns()">
          @if (allowSelection()) {
            <th>
              <mat-checkbox color="primary" (change)="changeAllCheckboxes($event)"> </mat-checkbox>
            </th>
          }
          @for (column of columns(); track $index) {
            <th [attr.aria-sort]="column.sortable ? sortAriaFor(column) : null">
              <app-sortable-header
                [field]="column.sortKey || column.id"
                [label]="column.name"
                [sortable]="!!column.sortable"
                [state]="sortState()"
                (sort)="sortChange.emit($event)"
              ></app-sortable-header>
            </th>
          }

          <th *ngIf="actions().length" [style.width.px]="100">
            {{ 'COMMON.ACTIONS' | translate }}
          </th>
        </tr>
        <tr *ngIf="isAdvancedColumns()">
          <ng-content select="[slot=advanced-columns]"> </ng-content>
        </tr>
      </thead>
      <tbody class="text-center">
        @for (row of data; track $index; let rowIndex = $index) {
          <tr
            [ngClass]="{
              'bg-header-soft-color table-text-selected': row.selected,
              'clickable-row': rowClick.observed,
            }"
            class="table-row-border"
            (click)="rowClick.observed && rowClick.emit(row)"
          >
            @if (allowSelection()) {
              <td>
                <mat-checkbox
                  color="primary"
                  [checked]="row.selected"
                  [disabled]="row.selectable === false"
                  (change)="row.selected = $event.checked; verifySelectedCheckboxes()"
                >
                </mat-checkbox>
              </td>
            }
            @for (column of columns(); track $index) {
              <td>
                <app-table-cell
                  [column]="column"
                  [row]="row"
                  [index]="rowIndex"
                  (statusClick)="onStatusClick($event)"
                >
                </app-table-cell>
              </td>
            }
            @if (actions().length) {
              <td>
                <div class="d-flex align-items-center justify-content-center actions-container">
                  <button mat-icon-button [matMenuTriggerFor]="desktopActionsMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu
                    #desktopActionsMenu="matMenu"
                    class="investor-actions-menu table-actions-menu"
                  >
                    @for (action of actions(); track $index) {
                      <button
                        mat-menu-item
                        (click)="emitAction(action, rowIndex, row)"
                        [disabled]="
                          action.disabled
                            ? action.disabled(row)
                            : action[(row.idArquivo || row.id) + DISABLED_SUFFIX] || false
                        "
                      >
                        <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
                        <span>{{ action.name | translate }}</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              </td>
            }
          </tr>
        } @empty {
          @if (emptyMessage()) {
            <tr>
              <td [colSpan]="columns().length + (allowSelection() ? 1 : 0) + (actions().length ? 1 : 0)" class="text-center p-4 text-muted">
                {{ emptyMessage() | translate }}
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <ng-template #mobile>
    <app-mobile-table
      [columns]="columns()"
      [actions]="actions()"
      [data]="data"
      (action)="emitActionFromMobile($event)"
    >
    </app-mobile-table>
  </ng-template>
</div>
